export enum AiModelName {
    PRIYA_SHARMA = 'Priya Sharma',
    SARAH_JOHNSON = 'Sarah Johnson',
    ARJUN_PATEL = 'Arjun Patel',
    MICHAEL_CHEN = 'Michael Chen',
}